import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { authApi } from '../api/monitor';
import { getToken, setToken } from '../api/client';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!getToken()) { setReady(true); return undefined; }
    authApi.me()
      .then((u) => alive && setUser(u))
      .catch(() => setToken(null))
      .finally(() => alive && setReady(true));
    return () => { alive = false; };
  }, []);

  const logout = useCallback(() => { setToken(null); setUser(null); }, []);

  useEffect(() => {
    window.addEventListener('am:unauthorized', logout);
    return () => window.removeEventListener('am:unauthorized', logout);
  }, [logout]);

  const login = useCallback(async (email, password) => {
    const res = await authApi.login(email.trim(), password); // throws Error(message) on failure
    setToken(res.token);
    setUser(res.data.user);
  }, []);

  const value = useMemo(() => ({ user, ready, login, logout, isAdmin: user?.role === 'admin' }), [user, ready, login, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
